// @flow

import clsx from 'clsx';

import { ProductIcon } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Text } from '@gandi/ui';

import styles from './DomainCount.scss';

const MAX_DOMAINS = 150;

type Props = { count: number };

export const DomainCount = ({ count }: Props): React.MixedElement => {
  const { __ } = useTranslator();

  const error = count > MAX_DOMAINS;
  return (
    <span className={clsx(styles.root, error && styles.error)}>
      <ProductIcon type="domain" className={styles.icon} />
      <Text weight="semibold">
        {__('%(nbDomains)s/%(max)s domains', {
          nbDomains: count,
          max: MAX_DOMAINS,
        })}
      </Text>
    </span>
  );
};
